export const ActionTypes = {
  LOADING: "LOADING_USER_GOAL",
  ERROR: "ERROR_USER_GOAL",
  SUCCESS: "SUCCESS_USER_GOAL",
  UPDATE_GOAL_SUCCESS: "UPDATE_GOAL_SUCCESS",
};
